// get_masterclass_review
export const GET_MASTERCLASS_REVIEW = 'get_masterclass_review';
export const GET_MASTERCLASS_REVIEW_SUCCESSFUL =
  'get_masterclass_review_successfull';
export const GET_MASTERCLASS_REVIEW_FAILED = 'get_masterclass_review_failed';

// create_masterclass_review
export const CREATE_MASTERCLASS_REVIEW = 'create_masterclass_review';
export const CREATE_MASTERCLASS_REVIEW_SUCCESSFUL =
  'create_masterclass_review_successfull';
export const CREATE_MASTERCLASS_REVIEW_FAILED =
  'create_masterclass_review_failed';

// update_masterclass_review
export const UPDATE_MASTERCLASS_REVIEW = 'update_masterclass_review';
export const UPDATE_MASTERCLASS_REVIEW_SUCCESSFUL =
  'update_masterclass_review_successfull';
export const UPDATE_MASTERCLASS_REVIEW_FAILED =
  'update_masterclass_review_failed';

// delete_masterclass_review
export const DELETE_MASTERCLASS_REVIEW = 'delete_masterclass_review';
export const DELETE_MASTERCLASS_REVIEW_SUCCESSFUL =
  'delete_masterclass_review_successfull';
export const DELETE_MASTERCLASS_REVIEW_FAILED =
  'delete_masterclass_review_failed';
